import { render, staticRenderFns } from "./PayInfo.vue?vue&type=template&id=b71a65d8&scoped=true&"
import script from "./PayInfo.vue?vue&type=script&lang=js&"
export * from "./PayInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71a65d8",
  null
  
)

export default component.exports